import { Grid, Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import Image from 'artkive/components/Image'
import ImageContainer from 'artkive/components/ImageContainer'
import theme from 'artkive/utils/theme'

import KeepsakeSection from './KeepsakeSection'

export const Section = withStyles({
  root: {
    backgroundColor: theme.colors.white.dark,
  },
})(KeepsakeSection)

export const IntroBlock = styled('div')({
  position: 'relative',
  maxWidth: 780,
  margin: '0 auto',
})

export const Sprite = styled(Image)(({ theme: { breakpoints } }) => ({
  position: 'absolute',
  top: -56,
  right: -43,
  width: 74,
  transform: 'scaleX(-1)',
  zIndex: 1,
  [breakpoints.down('sm')]: {
    top: -45,
    right: -21,
    width: 64,
  },
}))

export const Bubbles = styled(Image)(({ theme: { breakpoints } }) => ({
  position: 'absolute',
  top: 43,
  left: -84,
  width: 95,
  transform: 'rotate(96deg)',
  zIndex: 0,
  // On phones the text spans the full width, so the dots go just under the paragraph instead of behind it.
  [breakpoints.down('sm')]: {
    top: 'calc(100% - 19px)',
    left: 0,
    width: 64,
  },
}))

export const Foreground = styled('div')({
  position: 'relative',
  zIndex: 1,
})

export const Paragraph = styled('div')({
  '&:not(:first-child)': {
    marginTop: 24,
  },
})

// withStyles rather than styled, so the component prop still reaches Typography.
export const IntroText = withStyles(({ breakpoints }) => ({
  root: {
    maxWidth: 780,
    margin: '0 auto',
    lineHeight: 1.6,
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: 16,
      textAlign: 'left',
    },
  },
}))(Typography)

export const CardsWrapper = styled('div')({
  marginTop: 64,
})

export const Cards = styled(Grid)(({ theme: { breakpoints } }) => ({
  [breakpoints.down('sm')]: {
    rowGap: 48,
  },
}))

export const CardImage = styled(ImageContainer)({
  borderRadius: 8,
  overflow: 'hidden',
})

export const CardText = styled('div')(({ theme: { breakpoints } }) => ({
  marginTop: 24,
  textAlign: 'center',
  padding: '0 40px',
  [breakpoints.down('sm')]: {
    padding: 0,
  },
}))

export const CardBodyWrapper = styled('div')({
  marginTop: 16,
})

export const CardBody = styled(Typography)(({ theme: { breakpoints } }) => ({
  [breakpoints.down('sm')]: {
    textAlign: 'left',
  },
}))

export const OutroWrapper = styled('div')(({ theme: { breakpoints } }) => ({
  marginTop: 48,
  [breakpoints.down('sm')]: {
    marginTop: 64,
  },
}))

export const Outro = styled(Typography)(({ theme: { breakpoints } }) => ({
  maxWidth: 680,
  margin: '0 auto',
  textAlign: 'center',
  [breakpoints.down('sm')]: {
    textAlign: 'left',
  },
}))
